// Crop the same source region that CSS cover shows, without downloading invisible sides.
export function cropCandidates(base, imageWidth, imageHeight, width, height, position = '50% 50%') {
  if (!width || !height || !imageWidth || !imageHeight || !['50% 50%', 'center center'].includes(position)) return null;
  const scale = Math.max(width / imageWidth, height / imageHeight);
  const cropWidth = Math.min(imageWidth, Math.round(width / scale));
  const cropHeight = Math.min(imageHeight, Math.round(height / scale));
  const left = Math.round((imageWidth - cropWidth) / 2);
  const top = Math.round((imageHeight - cropHeight) / 2);
  const candidates = [1, 2, 3].map((dpr) => {
    const ratio = Math.min(dpr, cropWidth / width, cropHeight / height);
    const url = new URL(base);
    for (const [key, value] of Object.entries({ crop: 'region', crop_left: left, crop_top: top,
      crop_width: cropWidth, crop_height: cropHeight,
      width: Math.max(1, Math.round(width * ratio)), height: Math.max(1, Math.round(height * ratio)) })) url.searchParams.set(key, value);
    return `${url.href} ${dpr}x`;
  });
  return { srcset: candidates.join(', '), cropWidth, cropHeight, left, top };
}

if (typeof document !== 'undefined') {
  const mobile = window.matchMedia('(max-width: 749px)');
  for (const picture of document.querySelectorAll('[data-mobile-editorial-crop]')) {
    const image = picture.querySelector('img');
    const source = picture.querySelector('[data-mobile-crop-source]');
    if (!image || !source || !('ResizeObserver' in window) || window.Shopify?.designMode) continue;
    let failed = false;
    const update = (width, height) => {
      if (!mobile.matches || failed) { source.media = 'not all'; return; }
      // A skipped subtree can report zero; retain its prepared source instead of refetching the original.
      if (width <= 0 || height <= 0) return;
      const crop = cropCandidates(new URL(picture.dataset.imageUrl, location.href).href,
        Number(picture.dataset.imageWidth), Number(picture.dataset.imageHeight), width, height, getComputedStyle(image).objectPosition);
      if (!crop) { source.media = 'not all'; return; }
      if (source.srcset !== crop.srcset) source.srcset = crop.srcset;
      source.media = '(max-width: 749px)';
    };
    const observer = new ResizeObserver((entries) => {
      const entry = entries[0];
      if (entry) update(entry.contentRect.width, entry.contentRect.height);
    });
    const sync = () => {
      if (!mobile.matches) { source.media = 'not all'; observer.disconnect(); return; }
      observer.observe(image);
      // Derive reserved dimensions from the fixed-height frame while its content is skipped.
      const frame = picture.closest('.mobile-editorial-frame');
      const rect = frame?.getBoundingClientRect();
      if (rect) update(rect.width, rect.height);
    };
    image.addEventListener('error', () => { failed = true; source.media = 'not all'; observer.disconnect(); }, { once: true });
    mobile.addEventListener('change', sync);
    sync();
  }
}
